<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button color="dark" (click)="closeModal()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-segment [(ngModel)]="selectedRange" (ionChange)="onSegmentChange($event)">
    <ion-segment-button [value]="currentMonth">
      <ion-label>{{ currentMonth }}</ion-label>
    </ion-segment-button>
    <ion-segment-button value="Mes Anterior">
      <ion-label>Mes Anterior</ion-label>
    </ion-segment-button>
    <ion-segment-button value="Últimos Siete Días">
      <ion-label>Últimos Siete Días</ion-label>
    </ion-segment-button>
    <ion-segment-button value="Personalizado">
      <ion-label>Personalizado</ion-label>
    </ion-segment-button>
  </ion-segment>

  <div class="span-container">
    <span *ngIf="selectedRange != 'Personalizado'">Ve a la seccion de Personalizado para hacer una busqueda más específica</span>
  </div>
  <div class="container-dates" *ngIf="selectedRange != 'Personalizado'">
    <div class="summary-tile">
      <span class="tile-label">Fecha Inicial</span>
      <span class="tile-value">{{ startDate }}</span>
    </div>

    <div class="summary-tile">
      <span class="tile-label">Fecha Final</span>
      <span class="tile-value">{{ endDate }}</span>
    </div>
  </div>

  <div class="filter-container" *ngIf="selectedRange === 'Personalizado'">
    <div class="filter-field">
      <label class="filter-label">Rango de fechas</label>
      <div class="date-range">
        <mat-form-field appearance="none">
          <input matInput [matDatepicker]="pickerInicio" [(ngModel)]="startDateFilter" placeholder="Desde">
          <mat-datepicker-toggle matSuffix [for]="pickerInicio"></mat-datepicker-toggle>
          <mat-datepicker #pickerInicio></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="none">
          <input matInput [matDatepicker]="pickerFin" [(ngModel)]="endDateFilter" placeholder="Hasta">
          <mat-datepicker-toggle matSuffix [for]="pickerFin"></mat-datepicker-toggle>
          <mat-datepicker #pickerFin></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </div>
</ion-content>

<ion-footer style="top: -4px; left: -1px;">
  <ion-button expand="block" (click)="onRangeChange()" class="submit-button">
    Buscar
  </ion-button>
</ion-footer>
